import React from 'react';

const ComingSoon = ({ title }) => (
  <div style={styles.container}>
    <h2 style={styles.title}>{title}</h2>
    <p style={styles.text}>This page is coming soon.</p>
  </div>
);

const styles = {
  container: {
    padding: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '8px',
    color: '#111827',
  },
  text: {
    color: '#6b7280',
  },
};

export default ComingSoon;
